export default defineAppConfig({
  ui: {
    colors: {
      primary: 'indigo',
      secondary: 'sky',
      neutral: 'zinc',
    },
    inputMenu: {
      slots: {
        base: 'w-full',
        tagsInput: 'w-full',
      },
    },
    tabs: {
      compoundVariants: [
        {
          orientation: 'horizontal',
          variant: 'link',
          class: {
            list: 'border-b -mb-px',
            indicator: 'bottom-0 h-[2px]',
          },
        },
      ],
    },
  },
})
